/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Large_Few_Hedgehog_PeekInputs */

const fr_large_few_hedgehog_peek = /** @type {(inputs: Large_Few_Hedgehog_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmes`)
};

/**

* @param {Large_Few_Hedgehog_PeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const large_few_hedgehog_peek = /** @type {((inputs?: Large_Few_Hedgehog_PeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Large_Few_Hedgehog_PeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_large_few_hedgehog_peek(inputs)
});